import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils.js';

export interface EmptyProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Empty({ className, children, ...props }: EmptyProps) {
  return (
    <div className={cn('empty', className)} {...props}>
      {children}
    </div>
  );
}

export interface EmptyIconProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export function EmptyIcon({ className, children, ...props }: EmptyIconProps) {
  return (
    <span className={cn('empty-icon', className)} {...props}>
      {children}
    </span>
  );
}

export interface EmptyTitleProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function EmptyTitle({ className, children, ...props }: EmptyTitleProps) {
  return (
    <div className={cn('empty-title', className)} {...props}>
      {children}
    </div>
  );
}

export interface EmptyTextProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function EmptyText({ className, children, ...props }: EmptyTextProps) {
  return (
    <div className={cn('empty-text', className)} {...props}>
      {children}
    </div>
  );
}

export interface EmptyActionProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function EmptyAction({ className, children, ...props }: EmptyActionProps) {
  return (
    <div className={cn('empty-action', className)} {...props}>
      {children}
    </div>
  );
}
